"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TokenManager = _interopRequireDefault(require("./TokenManager"));
var _ColorScheme = _interopRequireDefault(require("./ColorScheme"));
var _FeatureVisibility = _interopRequireDefault(require("./FeatureVisibility"));
var _MapType = _interopRequireDefault(require("./MapType"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var AppleMaps = /*#__PURE__*/function (_Component) {
  _inherits(AppleMaps, _Component);
  var _super = _createSuper(AppleMaps);
  function AppleMaps(props) {
    var _this;
    _classCallCheck(this, AppleMaps);
    _this = _super.call(this, props);
    _this.state = {
      mapId: "map" + _TokenManager["default"].getInstance().getNewMapId()
    };
    return _this;
  }
  _createClass(AppleMaps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        initialMapType = _this$props.initialMapType,
        token = _this$props.token,
        colorScheme = _this$props.colorScheme,
        showsCompass = _this$props.showsCompass,
        showsMapTypeControl = _this$props.showsMapTypeControl,
        showsZoomControl = _this$props.showsZoomControl;
      _TokenManager["default"].getInstance().setToken(token);
      this.setState({
        mapkitToken: token
      });
      this.canvas = document.createElement('canvas');
      this.canvas.id = 'currentLocationOverride';
      mapkit.init({
        authorizationCallback: function authorizationCallback(done) {
          done(_TokenManager["default"].getInstance().getToken());
        }
      });
      this.map = new mapkit.Map(this.state.mapId);
      this.annotations = {};

      // Set initial mapType
      if (initialMapType !== undefined) {
        if (!_MapType["default"].isOneOf(initialMapType)) {
          console.error("Invalid initialMapType provided to AppleMaps component.");
        } else {
          this.map.mapType = initialMapType;
        }
      }
      if (colorScheme !== undefined) {
        if (!_ColorScheme["default"].isOneOf(colorScheme)) {
          console.error("Invalid colorScheme provided to AppleMaps component.");
        } else {
          this.map.colorScheme = colorScheme;
        }
      }
      if (showsCompass !== undefined) {
        if (!_FeatureVisibility["default"].isOneOf(showsCompass)) {
          console.error("Invalid showsCompass provided to AppleMaps component.");
        } else {
          this.map.showsCompass = showsCompass;
        }
      }
      if (showsMapTypeControl !== undefined) {
        this.map.showsMapTypeControl = showsMapTypeControl;
      }
      if (showsZoomControl !== undefined) {
        this.map.showsZoomControl = showsZoomControl;
      }

      //	Annotations
      if (children !== undefined && children.length) {
        children.forEach(function (child) {
          if (child.props.isAnnotation) {
            _this2.createAnnotation(child.props);
          }
        });
      } else if (children !== undefined && children.props) {
        if (children.props.isAnnotation) {
          this.createAnnotation(children.props);
        }
      }

      //	Image Annotations
      if (children !== undefined && children.length) {
        children.forEach(function (child) {
          if (child.props.isImageAnnotation) {
            _this2.createImageAnnotation(child.props);
          }
        });
      } else if (children !== undefined && children.props) {
        if (children.props.isImageAnnotation) {
          this.createImageAnnotation(children.props);
        }
      }

      // Current Location Override
      if (children !== undefined && children.length) {
        children.forEach(function (child) {
          if (child.type.name === 'CurrentLocationOverride') {
            _this2.createCurrentLocationOverride(child.props);
          }
        });
      } else if (children !== undefined && children.props) {
        if (children.type.name === 'CurrentLocationOverride') {
          this.createCurrentLocationOverride(children.props);
        }
      }

      //	Set main coords
      this.setMainCoords();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      var _this$props2 = this.props,
        token = _this$props2.token,
        children = _this$props2.children,
        latitude = _this$props2.latitude,
        longitude = _this$props2.longitude,
        spanLat = _this$props2.spanLat,
        spanLong = _this$props2.spanLong,
        zoomLevel = _this$props2.zoomLevel,
        width = _this$props2.width,
        height = _this$props2.height,
        autoAdjust = _this$props2.autoAdjust,
        colorScheme = _this$props2.colorScheme,
        showsCompass = _this$props2.showsCompass,
        showsMapTypeControl = _this$props2.showsMapTypeControl,
        showsZoomControl = _this$props2.showsZoomControl;
      _TokenManager["default"].getInstance().setToken(token);
      if (colorScheme !== prevProps.colorScheme) {
        if (!_ColorScheme["default"].isOneOf(colorScheme)) {
          console.error("Invalid colorScheme provided to AppleMaps component.");
        } else {
          this.map.colorScheme = colorScheme;
        }
      }
      if (showsCompass !== prevProps.showsCompass) {
        if (!_FeatureVisibility["default"].isOneOf(showsCompass)) {
          console.error("Invalid showsCompass provided to AppleMaps component.");
        } else {
          this.map.showsCompass = showsCompass;
        }
      }
      if (showsMapTypeControl !== prevProps.showsMapTypeControl) {
        this.map.showsMapTypeControl = showsMapTypeControl;
      }
      if (showsZoomControl !== prevProps.showsZoomControl) {
        this.map.showsZoomControl = showsZoomControl;
      }
      if ((prevProps.latitude !== latitude || prevProps.longitude !== longitude || prevProps.spanLat !== spanLat || prevProps.spanLong !== spanLong || prevProps.zoomLevel !== zoomLevel || prevProps.width !== width || prevProps.height !== height || prevProps.autoAdjust !== autoAdjust) && autoAdjust) {
        this.setMainCoords();
      }
      var currentAnnotationIds = [];
      if (children !== undefined && children.length) {
        children.forEach(function (child) {
          if (child.props.isAnnotation) {
            if (child.props.id) {
              currentAnnotationIds.push(child.props.id);
            }
            _this3.updateAnnotation(child.props);
          }
        });
      } else if (children !== undefined && children.props) {
        if (children.props.isAnnotation) {
          if (children.props.id) {
            currentAnnotationIds.push(children.props.id);
          }
          this.updateAnnotation(children.props);
        }
      }
      var prevChildren = prevProps.children;
      if (prevChildren !== undefined && prevChildren.length) {
        prevChildren.forEach(function (child) {
          var id = child.props.id;
          if (id === undefined) {
            return;
          }
          if (child.props.isAnnotation && !currentAnnotationIds.includes(id) && id in _this3.annotations) {
            _this3.removeAnnotation(child.props);
          }
        });
      } else if (prevChildren !== undefined && prevChildren.props) {
        var child = prevChildren;
        var id = child.props.id;
        if (id === undefined) {
          return;
        }
        if (child.props.isAnnotation && !currentAnnotationIds.includes(id) && id in this.annotations) {
          this.removeAnnotation(child.props);
        }
      }
      var checkCurrentLocationLatitudeChange, checkCurrentLocationLongitudeChange, checkCurrentLocationDirectionChange;
      if (typeof children !== 'undefined') {
        var firstChild = children[0] ? children[0] : children;
        var prevFirstChild = prevProps.children[0] ? prevProps.children[0] : prevProps.children;
        if (firstChild.props && prevFirstChild.props) {
          checkCurrentLocationLatitudeChange = firstChild.props.latitude !== prevFirstChild.props.latitude;
          checkCurrentLocationLongitudeChange = firstChild.props.longitude !== prevFirstChild.props.longitude;
          checkCurrentLocationDirectionChange = firstChild.props.direction !== prevFirstChild.props.direction;
        } else if (firstChild.props && !prevFirstChild.props) {
          checkCurrentLocationLatitudeChange = true;
          checkCurrentLocationLongitudeChange = true;
          checkCurrentLocationDirectionChange = true;
        }
      }
      if (checkCurrentLocationLatitudeChange || checkCurrentLocationLongitudeChange || checkCurrentLocationDirectionChange) {
        if (children !== undefined && children.length) {
          children.forEach(function (child) {
            if (child.type.name === 'CurrentLocationOverride') {
              _this3.updateCurrentLocationOverride(child.props);
            }
          });
        } else if (children !== undefined && children.props) {
          if (children.type.name === 'CurrentLocationOverride') {
            this.updateCurrentLocationOverride(children.props);
          }
        }
      }
    }
  }, {
    key: "createAnnotation",
    value: function createAnnotation(annotationOptions) {
      var id = annotationOptions.id,
        longitude = annotationOptions.longitude,
        latitude = annotationOptions.latitude,
        color = annotationOptions.color,
        glyphText = annotationOptions.glyphText,
        glyphImage = annotationOptions.glyphImage,
        glyphColor = annotationOptions.glyphColor,
        selected = annotationOptions.selected,
        title = annotationOptions.title,
        subtitle = annotationOptions.subtitle,
        visible = annotationOptions.visible;
      var MarkerAnnotation = mapkit.MarkerAnnotation;
      var coords = new mapkit.Coordinate(latitude, longitude);
      var newAnnotation = new MarkerAnnotation(coords, {
        color: color,
        title: title,
        subtitle: subtitle,
        selected: selected,
        visible: visible
      });
      glyphText ? newAnnotation.glyphText = glyphText : '';
      glyphImage ? newAnnotation.glyphImage = {
        1: glyphImage
      } : '';
      glyphColor ? newAnnotation.glyphColor = glyphColor : '';
      if (id) {
        this.annotations[id] = newAnnotation;
      } else {
        console.warn("Apple MapKitJS annotation created without id prop!");
      }
      this.map.addAnnotation(newAnnotation);
    }
  }, {
    key: "updateAnnotation",
    value: function updateAnnotation(annotationOptions) {
      var id = annotationOptions.id,
        latitude = annotationOptions.latitude,
        longitude = annotationOptions.longitude;
      if (id === undefined) {
        return;
      }
      if (!(id in this.annotations)) {
        this.createAnnotation(annotationOptions);
        return;
      }
      var annotation = this.annotations[id];
      if (latitude !== annotation.coordinate.latitude || longitude !== annotation.coordinate.longitude) {
        annotation.coordinate = new mapkit.Coordinate(latitude, longitude);
      }
    }
  }, {
    key: "removeAnnotation",
    value: function removeAnnotation(annotationOptions) {
      var id = annotationOptions.id;
      if (id === undefined) {
        return;
      }
      if (!(id in this.annotations)) {
        return;
      }
      this.map.removeAnnotation(this.annotations[id]);
      delete this.annotations[id];
    }
  }, {
    key: "createImageAnnotation",
    value: function createImageAnnotation(annotationOptions) {
      var longitude = annotationOptions.longitude,
        latitude = annotationOptions.latitude,
        url = annotationOptions.url,
        selected = annotationOptions.selected,
        title = annotationOptions.title,
        subtitle = annotationOptions.subtitle,
        visible = annotationOptions.visible;
      var ImageAnnotation = mapkit.ImageAnnotation;
      var coords = new mapkit.Coordinate(latitude, longitude);
      var newAnnotation = new ImageAnnotation(coords, {
        title: title,
        subtitle: subtitle,
        selected: selected,
        visible: visible,
        url: {
          1: url
        }
      });
      this.map.addAnnotation(newAnnotation);
    }
  }, {
    key: "createCurrentLocationOverride",
    value: function createCurrentLocationOverride(locationOptions) {
      var _this4 = this;
      var longitude = locationOptions.longitude,
        latitude = locationOptions.latitude,
        direction = locationOptions.direction;
      // AppleMaps needs options structured this way
      var options = {
        data: {
          direction: direction
        }
      };
      var coordinate = new mapkit.Coordinate(latitude, longitude);
      this.currentLocation = new mapkit.Annotation(coordinate, function () {
        var ctx = _this4.canvas.getContext('2d');
        ctx.beginPath();
        ctx.translate(150, 135);
        ctx.rotate(options.data.direction * Math.PI / 180);
        ctx.lineCap = 'round';
        ctx.moveTo(0, 7);
        ctx.lineTo(10, 12);
        ctx.lineTo(0, -13);
        ctx.lineTo(-10, 12);
        ctx.lineTo(0, 7);
        ctx.fillStyle = '#08F';
        ctx.strokeStyle = '#08F';
        ctx.stroke();
        ctx.fill();
        return _this4.canvas;
      }, options);
      this.map.showItems([this.currentLocation]);
    }
  }, {
    key: "updateCurrentLocationOverride",
    value: function updateCurrentLocationOverride(locationOptions) {
      var longitude = locationOptions.longitude,
        latitude = locationOptions.latitude;
      var coordinate = new mapkit.Coordinate(latitude, longitude);
      this.currentLocation.coordinate = coordinate;
    }
  }, {
    key: "setMainCoords",
    value: function setMainCoords() {
      var _this$props3 = this.props,
        longitude = _this$props3.longitude,
        latitude = _this$props3.latitude,
        spanLat = _this$props3.spanLat,
        spanLong = _this$props3.spanLong;
      this.map.region = new mapkit.CoordinateRegion(new mapkit.Coordinate(latitude, longitude), new mapkit.CoordinateSpan(spanLat ? spanLat : this.zoomLevel(), spanLong ? spanLong : this.zoomLevel()));
    }
  }, {
    key: "zoomLevel",
    value: function zoomLevel() {
      var zoomLevel = this.props.zoomLevel;
      switch (zoomLevel) {
        case 0:
          return 300;
        case 1:
          return 75;
        case 2:
          return 18.75;
        case 3:
          return 4.68;
        case 4:
          return 1.17;
        case 5:
          return 0.39;
        case 6:
          return 0.073;
        case 7:
          return 0.018;
        case 8:
          return 0.0045;
        default:
          return 0.35;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        width = _this$props4.width,
        height = _this$props4.height;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.state.mapId,
        style: {
          width: width,
          height: height
        }
      });
    }
  }]);
  return AppleMaps;
}(_react.Component);
AppleMaps.defaultProps = {
  width: '100wh',
  height: '100vh',
  zoomLevel: 6,
  longitude: 53.8008,
  latitude: -1.5491,
  autoAdjust: false
};
var _default = AppleMaps;
exports["default"] = _default;